export class InviteAcceptanceModel {  
        acceptStatus = 0; // 0 - No Action , 1 - Accepted , 2 - Rejected
        constructor(invitationInfo = null){  
                if (invitationInfo) {
                        this.acceptStatus = invitationInfo.acceptStatus || this.acceptStatus;
                }
        }    
}  